import React, { useRef, useState } from "react";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";
import { Table } from "./Table";
import Form from "./Form";

export enum AnswerType {
  Boolean = 1,
  Text = 2,
  Number =3
}

export interface IFloatQuestion {
  id?: number;
  question: string;
  answer_Type: AnswerType;
  created_By?: number;
  created_On?: string;
  additional_Question?:boolean;
}
export interface IModel {
  open: boolean;

  singleData: IFloatQuestion;
}

export const EmptyFloatQuestion: IFloatQuestion = {
  id: 0,
  question: "",
  answer_Type: AnswerType.Boolean,
  created_By: 0,
  created_On: "",
  additional_Question: false,
};

const FloatQuestionnaireMast = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState({ singleData: EmptyFloatQuestion, open: false} as IModel);
  const [reload, setReload] = useState(false);
  const toast = useRef<any>(null);
  const hideDialog = () => {
    setModal({ singleData: EmptyFloatQuestion, open: false });
  };

  return (
    <>
      <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} />
      <Form  singleData={modal.singleData}  open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} />
      <Toast ref={toast} />
    </>
  );
};

export default FloatQuestionnaireMast;
